import { registerLicense } from '../../misc/Certificates/LicenseRegistry.js';
/**
 * License that affirms that referenced data contains accurate information.
 */
export const AffirmationLicense = Object.freeze({
    $type$: 'License',
    name: 'Affirmation',
    description: '[signature.issuer] affirms that content of [data] is correct.'
});
registerLicense(AffirmationLicense, 'AffirmationCertificate');
export const AffirmationCertificateRecipe = {
    $type$: 'Recipe',
    name: 'AffirmationCertificate',
    rule: [
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['*']) }
        },
        {
            itemprop: 'license',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['License']) }
        }
    ]
};
export const AffirmationCertificateReverseMap = [
    'AffirmationCertificate',
    new Set(['*'])
];
//# sourceMappingURL=AffirmationCertificate.js.map